import { useQueries, useQuery } from "@tanstack/react-query";
import { api } from "shared/api";

const fetchMonthlyPayment = async (price: number) => {
  const res = await api().gersGetMonthlyPaymentAmount({
    duration: 60,
    loanAmount: price,
  });
  return res.data;
};

export const useMonthlyPayment = (price: number, enabled = true) => {
  return useQuery({
    queryKey: ["monthly-payment-amount-2", price],
    queryFn: () => fetchMonthlyPayment(price),
    enabled: enabled && price > 250 && price < 10000,
  });
};

export const useMonthlyPayments = (prices: number[]) => {
  return useQueries({
    queries: prices.map((price) => ({
      queryKey: ["monthly-payment-amount-2", price],
      queryFn: () => fetchMonthlyPayment(price),
      enabled: price > 250 && price < 10000,
    })),
  });
};
